export default __webpack_public_path__ + "static/media/media1.c9c5b546.jpeg";